import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyAccountComponent } from './my-account.component';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { RouterModule } from '@angular/router';
import { LogoutModule } from '../logout';
import { ClickOutsideModule } from 'ng-click-outside';
import { DaLinkModule } from '@draeger-academy/presentation/lib/modules/da-link';

@NgModule({
    declarations: [MyAccountComponent],
    exports: [MyAccountComponent],
    imports: [
        CommonModule,
        RouterModule,
        ClickOutsideModule,
        LogoutModule,
        TranslateModule.forChild(),
        LocalizeRouterModule.forChild([]),
        DaLinkModule
    ],
    providers: []
})
export class MyAccountModule {}
